import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetUsersForFundingPartnerQueryResponse, GetUsersForFundingPartnerQueryParams, GetUsersForFundingPartner400, GetUsersForFundingPartner401, GetUsersForFundingPartner403, GetUsersForFundingPartner404, GetUsersForFundingPartner410, GetUsersForFundingPartner422, GetUsersForFundingPartner429, GetUsersForFundingPartner500 } from "../types/GetUsersForFundingPartner";

export const getUsersForFundingPartnerQueryKey = (params?: GetUsersForFundingPartnerQueryParams) =>     [{url:`/api/credit-flow-backend/private/v1/users/view_by-funding-partner`},...(params ? [params] : [])] as const;
      export function getUsersForFundingPartnerQueryOptions <TData = GetUsersForFundingPartnerQueryResponse, TError = GetUsersForFundingPartner400 | GetUsersForFundingPartner401 | GetUsersForFundingPartner403 | GetUsersForFundingPartner404 | GetUsersForFundingPartner410 | GetUsersForFundingPartner422 | GetUsersForFundingPartner429 | GetUsersForFundingPartner500>(params?: GetUsersForFundingPartnerQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getUsersForFundingPartnerQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/private/v1/users/view_by-funding-partner`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/private/v1/users/view_by-funding-partner
 */

export function useGetUsersForFundingPartner <TData = GetUsersForFundingPartnerQueryResponse, TError = GetUsersForFundingPartner400 | GetUsersForFundingPartner401 | GetUsersForFundingPartner403 | GetUsersForFundingPartner404 | GetUsersForFundingPartner410 | GetUsersForFundingPartner422 | GetUsersForFundingPartner429 | GetUsersForFundingPartner500>(params?: GetUsersForFundingPartnerQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getUsersForFundingPartnerQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getUsersForFundingPartnerQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
